// extracted by mini-css-extract-plugin
module.exports = {"latestPostsContainer":"latest-posts-module--latest-posts-container--2Yh2h"};